import { useAuthContext } from "@/features/authentication/useAuthContext";
import type { Database } from "@/lib/database.types";
import { supabase } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";

export type RecipeCategoryRow = Database["public"]["Tables"]["recipe_categories"]["Row"];

export interface RecipeCategory {
    id: number;
    name: string;
    isCustom: boolean;
}

export function mapCategoryRowToCategory(row: RecipeCategoryRow): RecipeCategory {
    return {
        id: row.id,
        name: row.name,
        isCustom: !!row.user_id
    };
}

export function useGetRecipeCategories() {
    const { user } = useAuthContext();
    const { data, isPending, isError } = useQuery<RecipeCategory[]>({
        queryKey: ["recipeCategories"],
        queryFn: async () => {
            const { data, error } = await supabase.from("recipe_categories").select("*");

            if (error || !data) {
                console.error("Error fetching recipe categories:", error);
                throw error;
            }

            const categories: RecipeCategory[] = data
                .map(mapCategoryRowToCategory)
                .sort((a, b) => a.name.localeCompare(b.name));
            return categories;
        },
        enabled: !!user,
        staleTime: Infinity
    });

    return { data, isPending, isError };
}
